/** Query param `lang=en|ar` for localized API payloads (dashboards). */
export type ApiLang = "en" | "ar";

/**
 * Coerces any runtime value to `en` | `ar`. Use before every API `lang` query param
 * so `undefined` never becomes the string `"undefined"` in URLs.
 */
export function normalizeApiLang(
  language: string | undefined | null | ApiLang
): ApiLang {
  if (language === undefined || language === null) {
    return "en";
  }
  const s = String(language).trim();
  if (s === "" || s === "undefined" || s === "null") {
    return "en";
  }
  const base = s.split("-")[0].toLowerCase();
  return base === "ar" ? "ar" : "en";
}

/** Prefer `resolvedLanguage` so language is defined after i18next init and when switching locale. */
export function getApiLangFromI18n(i18n: {
  language?: string;
  resolvedLanguage?: string | null;
}): ApiLang {
  return normalizeApiLang(i18n.resolvedLanguage ?? i18n.language);
}
